export default __webpack_public_path__ + "static/media/dark-filled-bookmark.27c2e877.svg";